export default __webpack_public_path__ + "static/media/SingleSource_logo_blue rectangle.79139deb.svg";